// The slices of an Appwrite client SDK the shared code calls. Structural, so
// the web SDK (`appwrite`) and the native one (`react-native-appwrite`) both
// fit and the shared code depends on neither.

/** A row as the shared code reads it: `$id` plus whatever columns the table has. */
export interface RowLike {
	$id: string;
	[column: string]: unknown;
}

interface RowAddress {
	databaseId: string;
	tableId: string;
}

export interface RowsApi {
	getRow(p: RowAddress & { rowId: string }): Promise<RowLike>;
	listRows(p: RowAddress & { queries: string[] }): Promise<{ rows: RowLike[] }>;
	createRow(
		p: RowAddress & { rowId: string; data: Record<string, unknown>; permissions: string[] },
	): Promise<unknown>;
	upsertRow(
		p: RowAddress & { rowId: string; data: Record<string, unknown>; permissions: string[] },
	): Promise<unknown>;
}

export interface QueryApi {
	equal(attribute: string, value: string): string;
	orderAsc(attribute: string): string;
	limit(n: number): string;
	cursorAfter(rowId: string): string;
}

export interface PermissionApi {
	read(role: string): string;
	update(role: string): string;
}

export interface RoleApi {
	user(id: string): string;
}

export interface FilesApi {
	getFileDownload(p: { bucketId: string; fileId: string }): string;
}

/** Guarded: a thrown non-object must not raise a TypeError inside a classifier. */
export const codeOf = (e: unknown): number | undefined => {
	// Safe: reached only for a non-null object, and `code` is checked below.
	const code = typeof e === "object" && e !== null ? (e as { code?: unknown }).code : undefined;
	return typeof code === "number" ? code : undefined;
};
